import { getUserIdentity } from '~/redux-modules/identity'
import isFlagEnabled from '~/lib/isFlagEnabled'
import { DefaultRootState } from '~/types'

import { PDFViewerFLags } from './logic'

export const selectFlags = (state: DefaultRootState) => ({
    shouldHighLightStdTolerances: isFlagEnabled(
        getUserIdentity(state),
        PDFViewerFLags.HIGHLIGHT_STD_TOLERANCES,
        'true',
    ),
})
